import React, { Component } from 'react';

class getPreferencia extends Component {
  constructor(){
    super();
    this.state = {
        preferencias: [],
        preferencias_actual: [],
        acumulador : 0 ,
        secuencial_actual : 0 ,
        secuencial_actual_S : 0 ,
        preferencia :'',
        preferencia_adicional:''
    }
  }
  onSecuencial = (secuencial_actual,preferencia) =>{
    this.setState({
      secuencial_actual,
      preferencia
    })
  }
  onSecuencialS = (secuencial_actual_S) =>{
    this.setState({
      secuencial_actual_S
    })
  }
  grabar_preferencia = () =>{
    const preferencias_actual = this.state.preferencias_actual;
    if(preferencias_actual.length === 0) return null;
    let txt_preferencia = '';
    preferencias_actual.forEach(cp => {
        if(txt_preferencia===''){
          txt_preferencia =  cp.catalogo_maitre
        }else{
          txt_preferencia = txt_preferencia + "," + cp.catalogo_maitre
        }
    })
    this.props.ir_preferencia(txt_preferencia);
  }
  agregar = () =>{
    const secuencial_actual = this.state.secuencial_actual;
    const preferencias_actual= this.state.preferencias_actual;
    if(secuencial_actual>0){
      let sw_existe = 0;
      preferencias_actual.forEach(cp => {
        if(cp.secuencial===secuencial_actual){
          sw_existe = 1 ;
        }
      })
      if(sw_existe===1) return null;
      this.setState({
       preferencias_actual: [ ...this.state.preferencias_actual, {
         'secuencial': secuencial_actual,
         'catalogo_maitre': this.state.preferencia
       }]});
    }
  }
  eliminar = () =>{
    const secuencial_actual = this.state.secuencial_actual_S;
    if(secuencial_actual>0){
      this.setState(state => {
        const list = this.state.preferencias_actual.filter(item => item.secuencial !== secuencial_actual);
        return {
          preferencias_actual: list,
        };
      });
    }
  }
  renderTablePreferenciaS = () =>{
    const preferencias = this.state.preferencias_actual;
    return (
      preferencias.map(nota => (
        <div className="divTableBody" key={nota.secuencial}>
          <div className="divTableRow">
            <div className={nota.secuencial===this.state.secuencial_actual_S ? 'divTableCell_A' : 'divTableCell'} onClick={() => this.onSecuencialS(nota.secuencial)}>{nota.catalogo_maitre}</div>
          </div>
        </div>
          ))
        )
  }
  renderTablePreferencia = () => {
    const preferencias = this.state.preferencias;
    return (
      preferencias.map(nota => (
        <div className="divTableBody" key={nota.secuencial}>
          <div className="divTableRow">
            <div className={nota.secuencial===this.state.secuencial_actual ? 'divTableCell_A' : 'divTableCell'} onClick={() => this.onSecuencial(nota.secuencial,nota.catalogo_maitre)}>{nota.catalogo_maitre}</div>
          </div>
        </div>
          ))
        )
  }
  consultarPreferenciasAPI = () => {
    const url= this.props.url_proxyurl + this.props.url_global + "webservices/getPreferencias";

    fetch(url)
    .then(res => res.json())
    .then((data) => {
      this.setState({ preferencias : data })
    })
    .catch(console.log)
  }


  inputChangedHandler = (event) => {
      this.setState(
        {
          preferencia_adicional: event.target.value
        }
      )
  }
  agregar_adicional =  () =>{
    const preferencia_adicional = this.state.preferencia_adicional
    const preferencias = this.state.preferencias
    const secuencial_actual = -1;
    //alert("A")
    if(preferencia_adicional.trim()!==''){
           //alert("D")
           const cantidad = preferencias.length+1
           this.setState({
           preferencias: [ ...this.state.preferencias, {
             'secuencial': cantidad,
             'catalogo_maitre': preferencia_adicional
           }],
           preferencias_actual: [ ...this.state.preferencias_actual, {
             'secuencial': cantidad,
             'catalogo_maitre': preferencia_adicional
           }]});

          //const secuencial_actual = this.state.secuencial_actual;
          /*const preferencias_actual= this.state.preferencias_actual;
          if(secuencial_actual>0){
            //let sw_existe = 0;
            //preferencias_actual.forEach(cp => {
            //  if(cp.secuencial===secuencial_actual){
            //    sw_existe = 1 ;
            //  }
          //  })
            //if(sw_existe===1) return null;
            this.setState({
             preferencias_actual: [ ...this.state.preferencias_actual, {
               'secuencial': secuencial_actual,
               'catalogo_maitre':preferencia_adicional
             }]});*/
          //}
    }
  }
  render (){
    return (
      <React.Fragment>
      {this.props.lbl_item_preferencia}<br/>
      <div className="grid-container_preferencias">
      <div className="lbl_preferencias">
        <div className="divTable tb_nota">
          <div className="divTableHeading">
            <div className="divTableRow">
              <div className="divTableHead">Preferencia</div>
            </div>
          </div>
          {this.renderTablePreferencia()}
          <br/>
          <br/>
          <p style={{"background-color":"white"}}>Preferencia Personalizada</p>
          <input type="textbox"  style={{"width":"100%"}} value={this.state.preferencia_adicional}  onChange={(event)=>this.inputChangedHandler(event)} />
          <br/>
          <button  onClick={() => this.agregar_adicional()}>Agregar Preferencia Personalizada</button><br/>
        </div>
      </div>
      <div className="lbl_opciones">
        <button  onClick={() => this.agregar()}>Agregar</button><br/>
        <button  onClick={() => this.eliminar()}>Eliminar</button><br/><br/><br/><br/><br/><br/>
        <button  onClick={() => this.grabar_preferencia()}>GRABAR</button><br/><br/><br/>
        <button  onClick={() => this.props.cancelar_preferencia()}>CANCELAR</button><br/>
      </div>
      <div className="lbl_seleccionadas">
        <div className="divTable tb_nota">
          <div className="divTableHeading">
            <div className="divTableRow">
              <div className="divTableHead">Seleccionadas</div>
            </div>
          </div>
          {this.renderTablePreferenciaS()}
          <br/>
        </div>
      </div>
      <div className="lbl_nueva"></div>
    </div>
    </React.Fragment>
    )
  }
  componentDidMount() {
    this.consultarPreferenciasAPI();
  }
}
export default getPreferencia;
